import React from 'react';

class ServiceMenuCTAs extends React.Component {
  render() {
    return this.props.isEdit ? this.renderEditCTAs() : this.renderViewCTAs();
  }

  renderViewCTAs() {
    return (
      <div className="row">
        <div className="row__item row__item">
          <div
            className="btn btn--white btn--full-width"
            onClick={this.props.openGroceryList}
          >
            View Grocery List
          </div>
        </div>
      </div>
    );
  }

  renderEditCTAs() {
    return (
      <div className="row">
        <div className="row__item row__item--half">
          <div
            className="btn btn--white btn--full-width"
            onClick={this.props.openGroceryList}
          >
            View Grocery List
          </div>
        </div>
        <div className="row__item row__item--half">
          <div
            className="btn btn--white btn--full-width"
            onClick={this.props.openDishModal}
          >
            + Add Dish
          </div>
        </div>
      </div>
    );
  }
}
export default ServiceMenuCTAs;



// WEBPACK FOOTER //
// ./src/components/service/ServiceMenuCTAs.js